import {clearCache} from "./FetchCacheUtil";

const CLEAR_CACHE_TIMEOUT_MS = 2000;

let underLogout = false;
const logoutStartHandlers: Array<() => void> = [];

const runCleanupStep = (step: () => void) => {
  try {
    step();
  } catch (e) {
    console.error(e);
  }
};

const expireCookie = (name: string, domain?: string) => {
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainPart}`;
};

// Expires every cookie JS can see (host-only and domain variants); httpOnly cookies need a server-side logout.
const clearCookies = () => {
  const hostname = window.location.hostname;

  document.cookie.split(";").forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();
    if (!cookieName) {
      return;
    }

    expireCookie(cookieName);
    expireCookie(cookieName, hostname);
    expireCookie(cookieName, `.${hostname}`);
  });
};

// True once a logout has started; late writers (token refresh, cache, MSAL redirect) must check it.
export const isUnderLogout = () => underLogout;

// Lets other modules cancel their own in-flight work when a logout begins (keeps this file free of HttpService imports).
export const onLogoutStart = (handler: () => void) => {
  logoutStartHandlers.push(handler);
};

// Blocks late writers and cancels in-flight work. Call before anything else when logging out.
export const beginLogout = () => {
  underLogout = true;
  logoutStartHandlers.forEach((handler) => runCleanupStep(handler));
};

export const clearSessionData = async () => {
  beginLogout();

  // Synchronous steps first, so they complete even if the page unloads right after.
  runCleanupStep(() => localStorage.clear());
  runCleanupStep(() => sessionStorage.clear());
  runCleanupStep(clearCookies);

  try {
    // Time-boxed so a stuck IndexedDB can never block the redirect.
    await Promise.race([
      clearCache(),
      new Promise((resolve) => setTimeout(resolve, CLEAR_CACHE_TIMEOUT_MS))
    ]);
  } catch (e) {
    console.error(e);
  }
};
